"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildError = void 0;
function buildError(err) {
    return err ? { error: { message: err.message, stack: err.stack } } : {};
}
exports.buildError = buildError;
//# sourceMappingURL=build-error.js.map